/* @flow */
import {Component} from 'react';
import {connect} from 'react-redux';

import type {Node} from 'react';
import type {State as ReduxState} from '../../reducers/index';

type StateProps = {
    isOverlayVisible: boolean
};
type OwnProps = {children: Node};
type Props = OwnProps & StateProps;

/**
 * showOverlay can be expensive to the application
 */
export class OverlayUpdateInterceptor extends Component<Props> {
    shouldComponentUpdate(nextProps: Props) {
        const justBecameVisible =
            !this.props.isOverlayVisible && nextProps.isOverlayVisible;
        return !justBecameVisible;
    }

    render() {
        return this.props.children;
    }
}

const mapStateToProps = ({
    overlay: {showOverlay: isOverlayVisible}
}: ReduxState): StateProps => ({
    isOverlayVisible
});

export default connect(mapStateToProps)(OverlayUpdateInterceptor);
